var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{display:none;}\r\n\t.st1{fill:#FFFFFF;stroke:#1D1D1B;stroke-miterlimit:10;}\r\n\t.st2{display:inline;fill:#FF002A;}\r\n\t.st3{display:inline;}\r\n\t.st4{fill:#DC020A;}\r\n\t.st5{display:inline;fill:none;stroke:#1D1D1B;stroke-miterlimit:10;}\r\n\t.st6{fill:#A8ABAB;}\r\n\t.st7{fill:#EA4241;}\r\n\t.st8{fill:#DFCE27;}\r\n\t.st9{fill:#A6D7D0;}\r\n\t.st10{display:inline;fill:#A6D7D0;}\r\n\t.st11{fill:#FFFFFF;}\r\n\t.st12{display:none;fill:#1B84DB;}\r\n\t.st13{fill:#F7941E;}\r\n");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_2",
  className: "st0"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M402.8,136.8c0,0,17-20.2,15.9-36.1c0-10.2-2.4-26.4-20.5-42.3c-11.3-8.9-30.7-10.5-30.7-10.5 s-19.3,1.6-30.7,10.5c-18.1,15.9-20.5,32.1-20.5,42.3c-1.1,15.9,15.9,36.1,15.9,36.1l35.2,45L402.8,136.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M419,98.9c0-28.4-23-51.4-51.4-51.4c-28.4,0-51.4,23-51.4,51.4c0,10.9,3.4,21,9.2,29.3l0,0l0.2,0.3 c0.8,1.1,1.6,2.1,2.4,3.1l39.6,52l41.1-53.9c0-0.1,0.1-0.1,0.1-0.2l0-0.1l0,0C415.3,120.9,419,110.3,419,98.9z M367.6,127 c-15.2,0-27.6-12.4-27.6-27.6c0-15.2,12.4-27.6,27.6-27.6c15.2,0,27.6,12.4,27.6,27.6C395.2,114.6,382.8,127,367.6,127z"
}), /*#__PURE__*/React.createElement("g", {
  className: "st3"
}, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M418.9,98.5c0-28.4-23-51.4-51.4-51.4l0,24.7c15.2,0.1,27.5,12,27.5,27.2c0,15.2-12.3,28-27.5,28l0,56.2 l41.1-53.9c0-0.1,0.1-0.1,0.1-0.2l0-0.1l0,0C415.2,120.5,418.9,109.9,418.9,98.5z"
})));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_4"
}, /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 223.1,
  y: 213.3,
  className: "st5",
  width: 36,
  height: 28
}), /*#__PURE__*/React.createElement("rect", {
  x: 182.1,
  y: 213.3,
  className: "st5",
  width: 36,
  height: 28
}), /*#__PURE__*/React.createElement("rect", {
  x: 141.1,
  y: 213.3,
  className: "st5",
  width: 36,
  height: 28
}), /*#__PURE__*/React.createElement("rect", {
  x: 100.1,
  y: 213.3,
  className: "st5",
  width: 36,
  height: 28
}), /*#__PURE__*/React.createElement("rect", {
  x: 59.1,
  y: 213.3,
  className: "st5",
  width: 36,
  height: 28
}), /*#__PURE__*/React.createElement("rect", {
  x: 223.1,
  y: 245.3,
  className: "st5",
  width: 36,
  height: 28
}), /*#__PURE__*/React.createElement("rect", {
  x: 182.1,
  y: 245.3,
  className: "st5",
  width: 36,
  height: 28
}), /*#__PURE__*/React.createElement("rect", {
  x: 141.1,
  y: 245.3,
  className: "st5",
  width: 36,
  height: 28
}), /*#__PURE__*/React.createElement("rect", {
  x: 100.1,
  y: 245.3,
  className: "st5",
  width: 36,
  height: 28
}), /*#__PURE__*/React.createElement("rect", {
  x: 59.1,
  y: 245.3,
  className: "st5",
  width: 36,
  height: 28
})), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M109.5,297.6l5.9-7.8c0,0,1.6,25.6,7.8,34c6.2,8.4,8.6,10.5,8.1,25.9c0.1,7.3,6.2,13.2,8.1,15.6 c1.9,2.4,3.5,17.3-3.2,19.7c-6.7,2.4-14.8,1.1-10.9,8.4c3.9,7.3-11.7,31.8-11.7,31.8s-0.8,5.7,5.4,5.9c6.2,0.3,8.6-3,9.7-7 c1.1-4,4.3-13.5,8.6-15.6c4.3-2.2,11.9-4.3,11.9-9.7c0-5.4-3.5-18.6,0-21.6c3.5-3,16.2-15.1,18.1-14.6c1.9,0.5,14.7-0.8,15-7.7 c0.3-6.9,1.9-15-6.7-22s-8.5-9.6-13.9-9.7c-5.4-0.1-14.9-2-15.6-13.9s2.1-11.1,4.2-12.3s1.5-13.9,1.5-13.9s8.6-2.6,8.9-0.9 s-1.1,14.6-5.9,18.6c-4.9,4-1.9,12.8,1.3,13.5c3.2,0.7,9.7,0.9,12.4,4.3c2.7,3.4,16.4,12.8,17,14.2c0.5,1.3,2.6,3.2,2.4,14.4 c-0.1,11.2,0.4,18.9-7.6,19.8s-15.8,7.1-18.9,9.7s-6.9,2.3-5.4,20c0.8,9.6-5.5,13.2-8.9,14c-3.4,0.8-11.6,8-12.6,16 c-1,8.1,0.6,14.6-17.8,10.7c-12.1-1.4-12.3-3.8-11.5-11.5c0.8-7.7-0.4-6.9,3.4-8.3c3.8-1.4,5.9-6.3,7.7-11.3 c1.8-5.1,2.8-11.5-0.6-15c-3.4-3.4,1-9.3,6.5-9.5c5.5-0.2,12.7-1.6,12.9-6.3c0.2-4.7-4.9-7.5-6.3-12.1c-1.4-4.7-1.4-30.3-5.1-31.8 c-3.6-1.4-9.5-11.3-11.5-20.6C110.2,301.8,109.5,297.6,109.5,297.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M237.5,291.2l-28.1-28.1c-6.1-6.1-6.1-15.9,0-21.9l38.1-38.1c6.1-6.1,15.9-6.1,21.9,0l28.1,28.1 c6.1,6.1,6.1,15.9,0,21.9l-38.1,38.1C253.4,297.3,243.6,297.3,237.5,291.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M283,225.7l-8-8c-3-3-3-7.9,0-11l13-13c3-3,7.9-3,11,0l8,8c3,3,3,7.9,0,11l-13,13 C290.9,228.8,286,228.8,283,225.7z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 271.4,
  y: 214,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 236.0345 -138.2206)",
  className: "st8",
  width: 26.9,
  height: 3.5
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "220.2,174.6 236.7,193.5 219.5,210.7 201.5,193.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "197.6,148.7 217.7,171.7 198.8,190.6 176.9,169.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "169.5,116.6 194.5,145.2 173.6,166.1 146.4,139.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "133.7,75.5 165.6,112.1 142.1,135.6 107.3,101.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "86.4,21.2 128.7,69.7 101.8,96.5 55.8,51.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "198.9,195.9 217,213.1 199.9,230.3 180.2,214.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "174,172.4 196.1,193.3 177.2,212.2 153.3,193  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "143,143 170.6,169.1 149.6,190.1 119.9,166.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "103.6,105.6 138.8,139 115.2,162.5 77.2,132  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "51.4,56.2 98,100.4 71.1,127.2 20.8,86.9  "
})), /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "325.1,298.1 305.3,280.2 292.3,293.3 311.3,311.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "350.7,321.1 328.1,300.7 314.2,314.6 335.9,335.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "380,347.6 354,324.1 339.1,339 364.1,363.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "414.1,378.3 383.9,351.1 367.9,367.1 396.9,395.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "454.2,414.5 418.7,382.4 401.3,399.8 435.6,433.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "309.4,313.9 290.4,295.1 277.4,308.2 295.6,327.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "333.8,338 312.2,316.6 298.3,330.5 319,352.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "361.9,365.7 337,341.1 322.1,356 346,381.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "394.5,398 365.6,369.4 349.5,385.4 377.3,415.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st10",
  points: "432.9,435.9 398.8,402.2 381.5,419.6 414.2,454.6  "
})), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M264,236.7c-5.8-5.8-15.2-5.8-21,0c-5.8,5.8-5.8,15.2,0,21c5.8,5.8,15.2,5.8,21,0 C269.8,251.9,269.8,242.5,264,236.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M264,236.7c-5.8-5.8-15.2-5.8-21,0c-5.8,5.8-5.8,15.2,0,21c5.8,5.8,15.2,5.8,21,0 C269.8,251.9,269.8,242.5,264,236.7z M244.7,256c-4.8-4.8-4.8-12.7,0-17.5s12.7-4.8,17.5,0s4.8,12.7,0,17.5S249.5,260.8,244.7,256z "
}), /*#__PURE__*/React.createElement("path", {
  id: "path3812",
  className: "st12",
  d: "M404.1,268.8c-12.7,9-30.3,6.1-39.4-6.6c-9-12.7-6.1-30.3,6.6-39.4c12.7-9,30.3-6.1,39.4,6.6 C419.8,242.2,416.8,259.8,404.1,268.8z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "path3814",
  className: "st13",
  d: "M200.9,295.2c4.2,5.9,10.2,9.6,16,10.3l2.2-5.6c-4.8-0.1-10-3-13.6-8 c-3.3-4.6-4.4-10-3.4-14.4l-5.9,0C195.4,283,196.9,289.5,200.9,295.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3822",
  className: "st13",
  d: "M211.6,288.3c2.4,3.4,5.9,5.6,9.6,6.4l1.9-4.7c-2.7-0.7-5.3-2.4-7-4.8 c-1.7-2.3-2.4-5.1-2.3-7.7l-5.1,0C208.3,281.2,209.3,285,211.6,288.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3824",
  className: "st13",
  d: "M190.8,302.6c5.6,7.8,13.6,12.7,21.8,14.1l2.1-5.3c-6.7-0.6-13.9-4.9-19-12.1 c-5-7.1-6.8-15.2-5.3-21.7l-5.9,0C183.3,285.7,185.2,294.8,190.8,302.6z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "293.7,319.7 277.2,300.8 294.4,283.6 312.3,301  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "316.2,345.5 296.2,322.5 315,303.7 336.9,324.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "344.3,377.7 319.3,349.1 340.3,328.1 367.5,354.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "380.1,418.8 348.2,382.2 371.7,358.7 406.5,392.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "427.5,473 385.2,424.6 412,397.7 458.1,442.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "315,298.3 296.8,281.1 314,264 333.6,279.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "339.9,321.9 317.7,301 336.6,282.1 360.5,301.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "370.8,351.2 343.3,325.1 364.2,304.2 394,328  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "410.3,388.6 375.1,355.3 398.6,331.8 436.7,362.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "462.5,438 415.9,393.9 442.7,367.1 493.1,407.4  "
})));
function SvgSatelliti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 512,
    height: 512,
    xlinkHref: "satelliti.png",
    transform: "matrix(1.0186 0 0 1.0186 -9.5355 -14.3676)"
  })), _ref3, /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 720,
    height: 1280,
    xlinkHref: "photo_6021320514796107783_y.jpg",
    transform: "matrix(1 0 0 1 -606.0114 -203.5042)"
  })), _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatelliti);
export default __webpack_public_path__ + "static/media/satelliti.762b177c98aa2b4f5609f2c86abea480.svg";
export { ForwardRef as ReactComponent };